import { render, staticRenderFns } from "./customerFollow.vue?vue&type=template&id=9d385f12"
import script from "./customerFollow.vue?vue&type=script&lang=js"
export * from "./customerFollow.vue?vue&type=script&lang=js"
import style0 from "./customerFollow.vue?vue&type=style&index=0&id=9d385f12&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports